import { useState } from "react"
import styles from "./avatar-generator.module.css"
import ExpandableSection from "./ExpandableSection"

const BACKGROUNDS = ["b6e3f4", "c0aede", "d1d4f9", "ffd5dc", "ffdfbf"]
const HAIR = ["long01", "long02", "long03", "long04", "long05", "long06", "long07", "long08", "long09", "long10",
  "long11", "long12", "long13", "long14", "long15", "long16", "long17", "long18", "long19", "long20", "long21",
  "short01", "short02", "short03", "short04", "short05", "short06", "short07", "short08", "short09", "short10",
  "short11", "short12", "short13", "short14", "short15", "short16", "short17", "short18", "short19", "short20",
  "short21", "short22", "short23", "short24"]
const CLOTHING = ["variant01", "variant02", "variant03", "variant04", "variant05", "variant06", "variant07", "variant08", "variant09", "variant10", "variant11", "variant12", "variant13", "variant14", "variant15", "variant16", "variant17", "variant18", "variant19", "variant20", "variant21", "variant22"]
const CLOTHINGCOLOR = ["00b159", "5bc0de", "44c585", "88d8b0", "428bca", "03396c", "ae0001", "d11141", "ff6f69", "ffc425", "ffd969", "ffeead"]
const EYES = ["variant01", "variant02", "variant03", "variant04", "variant05", "variant06", "variant07", "variant08", "variant09", "variant10", "variant11", "variant12"]
const HAIRCOLOR = ["000000", "009bbd", "91cb15", "603a14", "611c17", "28150a", "83623b", "603015", "612616", "a78961", "bd1700", "cab188"]
const SKINCOLOR = ["8d5524", "a26d3d", "b68655", "cb9e6e", "e0b687", "eac393", "f5cfa0", "ffdbac"]
const MOUTH = ["happy01","happy02","happy03","happy04","happy05","happy06","happy07","happy08","happy09","happy10","happy11","happy12","happy13","sad01","sad02","sad03","sad04","sad05","sad06","sad07","sad08","sad09","sad10"];


export default function AvatarGenerator({ onGenerate }) {
  const [background, setBackground] = useState("b6e3f4")
  const [hairstyle, setHairstyle] = useState("long01")
  const [clothing, setClothing] = useState("variant01")
  const [clothingColor, setClothingColor] = useState("00b159")
  const [eyes, setEyes] = useState("variant01")
  const [hairColor, setHairColor] = useState("000000")
  const [skinColor, setSkinColor] = useState("8d5524")
  const [mouth, setMouth] = useState("happy01")


  const [isGenerating, setIsGenerating] = useState(false)
  const [generatedUrl, setGeneratedUrl] = useState(null)
  const [error, setError] = useState(null)

  const generateAvatar = async () => {
    setIsGenerating(true)
    setError(null)
    try {
      const params = new URLSearchParams({
        scale: "100",
        size: "512",
        backgroundColor: background,
        backgroundType: "gradientLinear",
        skinColor,
        clothing,
        clothingColor,
        eyes,
        hair: hairstyle,
        hairColor,
        mouth
      })

      const url = `https://api.dicebear.com/7.x/pixel-art/svg?${params.toString()}`

      console.log("[v0] Generated avatar URL:", url)

      // The URL is valid as long as it's properly formatted. Just set it directly.
      setGeneratedUrl(url)
      onGenerate(url, {
        background,
        skinColor,
        hairstyle,
        hairColor,
        clothing,
        clothingColor,
        eyes,
        mouth
      })
    } catch (error) {
      console.error("[v0] Error generating avatar:", error.message)
      setError("Error generating avatar. Please try again.")
    } finally {
      setIsGenerating(false)
    }
  }

  return (
    <div className={styles.generatorContainer}>

      {/* Style Selection */}
      <div className={styles.customizationSection}>
        {/* Background Selection */}
        <ExpandableSection label="Background">
          {BACKGROUNDS.map((bg) => (
            <button
              key={bg}
              className={`${styles.optionButton} ${background === bg ? styles.optionActive : ""}`}
              onClick={() => setBackground(bg)}
              title={bg}
            >
              <div className={styles.optionPreview} style={{ backgroundColor: `#${bg}` }} />
            </button>
          ))}
        </ExpandableSection>

        <ExpandableSection label="Skin Color">
          {SKINCOLOR.map((bg) => (
            <button
              key={bg}
              className={`${styles.optionButton} ${skinColor === bg ? styles.optionActive : ""}`}
              onClick={() => setSkinColor(bg)}
              title={bg}
            >
              <div className={styles.optionPreview} style={{ backgroundColor: `#${bg}` }} />
            </button>
          ))}
        </ExpandableSection>

        <ExpandableSection label="Hairstyle">
          {HAIR.map((hair) => (
            <button
              key={hair}
              className={`${styles.optionButton} ${hairstyle === hair ? styles.optionActive : ""}`}
              onClick={() => setHairstyle(hair)}
              title={hair}
            >
              <div className={styles.optionPreview}>
                <img src={`https://api.dicebear.com/7.x/pixel-art/svg?hair=${hair}&skinColor=e0b687`} alt={hair} />
              </div>
              <span className={styles.optionName}>{hair}</span>
            </button>
          ))}
        </ExpandableSection>

        <ExpandableSection label="Hair Color">
          {HAIRCOLOR.map((bg) => (
            <button
              key={bg}
              className={`${styles.optionButton} ${hairColor === bg ? styles.optionActive : ""}`}
              onClick={() => setHairColor(bg)}
              title={bg}
            >
              <div className={styles.optionPreview} style={{ backgroundColor: `#${bg}` }} />
            </button>
          ))}
        </ExpandableSection>

        <ExpandableSection label="Cloth">
          {CLOTHING.map((c) => (
            <button
              key={c}
              className={`${styles.optionButton} ${clothing === c ? styles.optionActive : ""}`}
              onClick={() => setClothing(c)}
              title={c}
            >
              <div className={styles.optionPreview}>
                <img src={`https://api.dicebear.com/7.x/pixel-art/svg?clothing=${c}&skinColor=e0b687`} alt={c} />
              </div>
              <span className={styles.optionName}>{c.replace("-", " ")}</span>
            </button>
          ))}
        </ExpandableSection>

        <ExpandableSection label="Cloth Color">
          {CLOTHINGCOLOR.map((bg) => (
            <button
              key={bg}
              className={`${styles.optionButton} ${clothingColor === bg ? styles.optionActive : ""}`}
              onClick={() => setClothingColor(bg)}
              title={bg}
            >
              <div className={styles.optionPreview} style={{ backgroundColor: `#${bg}` }} />
            </button>
          ))}
        </ExpandableSection>

        <ExpandableSection label="Eyes">
          {EYES.map((eye) => (
            <button
              key={eye}
              className={`${styles.optionButton} ${eyes === eye ? styles.optionActive : ""}`}
              onClick={() => setEyes(eye)}
              title={eye}
            >
              <div className={styles.optionPreview}>
                <img src={`https://api.dicebear.com/7.x/pixel-art/svg?eyes=${eye}&skinColor=e0b687`} alt={eye} />
              </div>
              <span className={styles.optionName}>{eye}</span>
            </button>
          ))}
        </ExpandableSection>

        <ExpandableSection label="Mouth">
          {MOUTH.map((m) => (
            <button
              key={m}
              className={`${styles.optionButton} ${mouth === m ? styles.optionActive : ""}`}
              onClick={() => setMouth(m)}
              title={m}
            >
              <div className={styles.optionPreview}>
                <img src={`https://api.dicebear.com/7.x/pixel-art/svg?mouth=${m}&skinColor=e0b687`} alt={m} />
              </div>
              <span className={styles.optionName}>{m}</span>
            </button>
          ))}
        </ExpandableSection>

      </div>

      {error && <div className={styles.errorMessage}>{error}</div>}

      <button
        className={`${styles.generateButton} ${isGenerating ? styles.generating : ""}`}
        onClick={generateAvatar}
        disabled={isGenerating}
      >
        {isGenerating ? "Generating..." : "Generate Avatar"}
      </button>
    </div >
  )
}
